import React, { useState } from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function AccordionRender({ node }) {
  const content = node.content || {};
  const title = content.title || 'FAQ Frage hier eingeben';
  const text = content.text || 'Antworttext hier eingeben. Im Live-Modus kann der Nutzer hier klicken, um den Text auszuklappen.';
  
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ 
        width: '100%', 
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '8px',
        overflow: 'hidden',
        background: 'rgba(255,255,255,0.02)'
    }}>
      <div 
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: '16px 20px',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: '600',
          color: 'var(--tef-primary, #00A9E0)'
        }}
      >
        <span>{title}</span>
        <span>{isOpen ? '−' : '+'}</span>
      </div>
      
      {isOpen && (
        <div style={{
          padding: '0 20px 20px 20px',
          color: '#cbd5e1',
          lineHeight: '1.6'
        }}>
          {text}
        </div>
      )}
    </div>
  );
}

registry.register('Accordion', {
  label: 'Aufklapp-Box (FAQ)',
  icon: '🔽', 
  category: 'advanced',
  component: AccordionRender,
  
  defaultProps: {
    content: {
      title: 'Häufig gestellte Frage',
      text: 'Hier ist die Antwort auf die Frage. Sie können diesen Text im Eigenschaften-Panel rechts ändern.'
    },
    style: {
      desktop: {
        marginBottom: '10px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Inhalt',
          fields: [
            { name: 'content.title', label: 'Titel / Frage', type: 'text' },
            { name: 'content.text', label: 'Inhalt / Antwort', type: 'text' }
          ]
        }
      ]
    }
  ]
});
